module.exports = ".feather {\n  width: 24px;\n  height: 24px; }\n"